export const CARA_BAYAR_KELAS_3: Record<string, string> = {
  A2: "BPJS PBI",
  A3: "KIS",
  KJ: "Jamkesda",
  JK: "Bapel Jamkesos",
  AK: "Askes Sosial"
};
